import BaseService from '@/api/services/index'
import Campaign from '@/api/models/Campaign'
import MessageDto from '@/api/dto/MessageDto'
import ExportOrderResponse, { ExportOrderResult } from '@/api/dto/ExportOrderResponse'

export default class CampaignService extends BaseService {
    public async getCampaigns (accountId: number|undefined): Promise<Array<Campaign>> {
        return this.api.get<never, Array<Campaign>>(
            this.getUrl('account_get_campaigns', { accountId: accountId })
        )
    }

    public async createCampaign (accountId: number|undefined, campaign: Campaign): Promise<Campaign> {
        return this.api.post<Campaign, Campaign>(
            this.getUrl('account_create_campaign', { accountId: accountId }),
            campaign
        )
    }

    public async updateCampaign (accountId: number|undefined, campaign: Campaign): Promise<Campaign> {
        return this.api.patch<Campaign, Campaign>(
            this.getUrl('account_update_campaign', { accountId: accountId, campaignId: campaign.id }),
            campaign
        )
    }

    public async deleteCampaign (accountId: number|undefined, campaignId: number): Promise<MessageDto> {
        return this.api.delete<Campaign, MessageDto>(
            this.getUrl('account_delete_campaign', { accountId: accountId, campaignId: campaignId })
        )
    }

    public async deleteCampaignItems (accountId: number|undefined, campaignId: number): Promise<MessageDto> {
        return this.api.delete<Campaign, MessageDto>(
            this.getUrl('account_delete_campaign_items', { accountId: accountId, campaignId: campaignId })
        )
    }

    public async getAct (accountId: number|undefined, campaignId: number): Promise<void> {
        return this.api.getFile<Campaign, void>(
            this.getUrl('account_get_campaign_act', { accountId: accountId, campaignId: campaignId })
        )
    }

    public async exportOrder (campaignId: number, accountId: number, data: Record<string, string>): Promise<ExportOrderResponse> {
        return this.api.post<Record<string, string>, ExportOrderResponse>(
            this.getUrl('account_export_order', { accountId, campaignId }),
            data
        )
    }

    public async getLatestExportOrderResult (campaignId: number, accountId: number): Promise<ExportOrderResult> {
        return this.api.get<never, ExportOrderResult>(
            this.getUrl('account_export_order_latest_result', { accountId, campaignId })
        )
    }

    public async getExportOrderResult (campaignId: number, accountId: number, runId: string): Promise<ExportOrderResult> {
        return this.api.get<never, ExportOrderResult>(
            this.getUrl('account_export_order_result', { accountId, campaignId, runId })
        )
    }
}
